/* External */
import window from 'global';

export function isVidaa() {
  return !!window.Hisense_GetDeviceID
    || /vidaa|hisense/i.test(navigator.userAgent);
}
export function getDeviceInfo() {
  const [, sdkVersion] = /vidaa\/([\d+.]+)/i.exec(navigator.userAgent) || [];
  const version = window.Hisense_GetFirmWareVersion?.();
  const resolution = window.Hisense_GetResolution?.();
  const resolutionSplit = resolution.split(',');

  return {
    version,
    sdkVersion: sdkVersion || version,
    screenWidth: resolutionSplit[0],
    screenHeight: resolutionSplit[1],
    modelName: window.Hisense_GetModelName?.(),
    uhd: window.Hisense_Get4KSupportState?.(),
    hdr: window.Hisense_GetSupportForHDR?.(),
  };
}
